var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 26 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.962 6.795C20.226 2.914 16.944 0 13 0 9.87 0 7.15 1.845 5.796 4.545 2.535 4.905 0 7.774 0 11.25 0 14.974 2.914 18 6.5 18h14.083C23.573 18 26 15.48 26 12.375c0-2.97-2.22-5.378-5.038-5.58Zm-.379 8.955H6.5c-2.394 0-4.333-2.014-4.333-4.5 0-2.306 1.657-4.23 3.856-4.466l1.16-.124.541-1.069C8.754 3.533 10.768 2.25 13 2.25c2.838 0 5.287 2.093 5.84 4.984l.324 1.687 1.658.124c1.69.113 3.011 1.586 3.011 3.33 0 1.856-1.462 3.375-3.25 3.375ZM8.667 10.125h2.762V13.5h3.142v-3.375h2.762L13 5.625l-4.333 4.5Z"
  })));
};
export { SvgUpload as ReactComponent };